/**
 * Tutorial-specific strings for onboarding flows and tutorial invitations.
 */
export const tutorials = {
  invitation: {
    title: "New to Markeroo? Take a 3-minute tutorial",
    description:
      "Learn how to create criteria and see Markeroo\u2019s feedback in action. You\u2019ll mark up your first student paper in just a few clicks.",
    startButton: "Start Tutorial",
    skipTitle: "Skip the tutorial?",
    skipMessage: "You can always start the tutorial later by creating a new assignment without papers.",
    neverShowAgainLabel: "Never show this invitation again",
  },
} as const;
